import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { AcmicService, ModalOptions } from '@mapfre-design-library/src/public_api';
import { ClaimsService } from '@services/_claims/claims.service';
import{ NavigationService } from '@services/navigation.service';
import { ActionType } from '@models/widget/action-type.enum';
import { Router } from '@angular/router';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreModalComponent, MapfreButtonComponent],
  selector: 'app-claim-modal',
  templateUrl: './claim-modal.component.html',
  styleUrls: ['./claim-modal.component.scss'],
})
export class ClaimModalComponent implements OnInit {
  claimModal: ModalOptions;
  hideModal = false;
  modalIcon: string
  @Input() policies: any = [];
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter();
  @ViewChild(MapfreModalComponent) modalComponent!: MapfreModalComponent;
 
  isAcmic = false;
  constructor(
    private claimsService: ClaimsService,
    private acmicService: AcmicService,
    private navService: NavigationService,
    private router: Router
  ) {
    this.isAcmic = this.acmicService.isACMIC();
    this.claimModal = new ModalOptions({
      additionalButtonClasses: 'ghost primary a-h24 x-small-btn sendDocBtn',
      additionalClasses: 'modal-medium modal-dialog modal-center-on-page modal-dialog-scrollable upload-document-modal',
      buttonCopy: 'REPORT_A_CLAIM',
      modalId: 'reportClaimId',
      modalTranslateCopy: `${this.isAcmic ? 'REPORTCLAIM' : ''}`,
      size: 'width-350',
      typeOfModal: 'default',
      modalName: 'report_Claim',
    });
  }

  onReportClaimClick(policy: any){
    this.navService.saveCurrentAction(ActionType.ReportClaim);
    this.claimsService.setClaimURL(policy);
    const url = this.router.serializeUrl(this.router.createUrlTree(["my-insurance", "reportClaim"]))
    window.open(url, '_blank');
    this.resetHideModal()
  }

  resetHideModal() {
    this.hideModal = !this.hideModal;
  }

  openModal() {
    this.modalComponent.showModal();
  }

  ngOnInit(): void { 
    this.modalIcon = this.isAcmic 
              ? "./assets/img/images/widgets/modal-report-claim-acmic.svg"
              : "./assets/img/images/widgets/modal-report-claim.svg";
  }
}